const getServiceEndpoint = environment => {
    return environment === 'production'
        ? 'https://8jctu0kz0e.execute-api.eu-west-2.amazonaws.com/release'
        // : 'https://5m7qmb9910.execute-api.eu-west-2.amazonaws.com/dev'
        : 'https://q9tm9q0le0.execute-api.eu-west-2.amazonaws.com/staging'
}

export default {
    getServiceEndpoint,
}
